import { useEffect } from 'react';
import { getContentType } from '../../../Utils/helper';
import {
  IVFCarouselCSS,
  IVFCarouselWrapper,
} from '../../IVF/IVFCarousel/styled';
import {
  CarouselContent,
  CarouselLeftSection,
  CarouselRightSection,
  CarouselTitle,
  SEOCarouselContainer,
} from './styled';
import { fireServedSectionEvent } from '../../../Utils/useFirebase';

export default function TopSeoCarousel(props) {
  const { data, isParentingPage } = props;
  useEffect(() => {
    fireServedSectionEvent(data?.heading, data?.itemId, getContentType());
  }, []);
  return (
    <IVFCarouselWrapper isParentingPage={isParentingPage} id="topCarousel">
      <IVFCarouselCSS fromStage>
        {/* <Carousel
                    showIndicators={false}
                    showThumbs={false}
                    emulateTouch
                    showArrows={false}
                    showStatus={false}
                    autoPlay={false}
                    infiniteLoop={true}
                > */}
        <SEOCarouselContainer color={data?.sectionBgColorStart}>
          <CarouselLeftSection>
            <CarouselTitle>{data?.heading}</CarouselTitle>
            <CarouselContent
              dangerouslySetInnerHTML={{
                __html: data?.htmlText,
              }}
            ></CarouselContent>
          </CarouselLeftSection>
          <CarouselRightSection>
            <img
              src={data?.mobileWebImage}
              srcSet={`${data?.mobileWebImage}?tr=w-360,q-80 2w, ${data?.desktopImage}?tr=w-608,q-80 608w`}
              sizes="(max-width: 720px) 2px,608px"
              fetchpriority="high"
              alt=""
            />
          </CarouselRightSection>
        </SEOCarouselContainer>
        {/* </Carousel> */}
      </IVFCarouselCSS>
    </IVFCarouselWrapper>
  );
}
